import { OgpApiService } from 'ogp/services/ogp-api-service';
import { Site } from 'shared/hooks';
import { HqApiService } from 'hq/services/hqApiService';
import {
  WorkersAvailabilityPaginated,
  workersAvailabilityPaginatedSchema,
} from './availability-service.schema';
import {
  GetWorkerAvailabilityDto,
  GetWorkersAvailabilityDto,
  UpdateWorkersAvailabilityDto,
} from './availability-service.dto';

export type GetWorkersAvailabilityParams = {
  site: Site;
  search: string | undefined;
  fromDate: string;
  pageParam: number;
  pageSizeParam: number;
};

export class AvailabilityService {
  constructor(
    private readonly ogpApiService: OgpApiService,
    private readonly hqApiService: HqApiService
  ) {}

  public updateWorkerAvailability = async (
    updateDto: UpdateWorkersAvailabilityDto,
    site: Site
  ): Promise<void> => {
    if (site === 'ogp') {
      await this.ogpApiService.update({
        path: `availability/edit`,
        body: updateDto,
      });
    } else {
      throw new Error('Not implemented');
    }
  };

  public getWorkersAvailability = async (
    params: GetWorkersAvailabilityParams
  ): Promise<WorkersAvailabilityPaginated> => {
    const workersAvailability = await this.getWorkersAvailabilityImpl(params);

    return workersAvailabilityPaginatedSchema.parse(workersAvailability);
  };

  private async getWorkersAvailabilityImpl(
    params: GetWorkersAvailabilityParams
  ): Promise<GetWorkersAvailabilityDto> {
    if (params.site === 'ogp') {
      return await this.ogpApiService.get<GetWorkersAvailabilityDto>({
        path: `availability/workers`,
        params: {
          search: params.search,
          pageParam: params.pageParam,
          pageSizeParam: params.pageSizeParam,
          fromDate: params.fromDate,
        },
      });
    }
    if (params.site === 'hq') {
      return await this.hqApiService.get<GetWorkersAvailabilityDto>({
        path: `availability/flexworkers`,
        params: {
          search: params.search,
          pageParam: params.pageParam,
          pageSizeParam: params.pageSizeParam,
          fromDate: params.fromDate,
        },
      });
    }

    throw new Error('Not implemented');
  }
  public async getWorkerAvailability(
    site: Site,
    workerId: string | null,
    fromDate: string,
    toDate: string
  ): Promise<GetWorkerAvailabilityDto> {
    if (site === 'ogp' && workerId) {
      return await this.ogpApiService.get<GetWorkerAvailabilityDto>({
        path: `availability/${workerId}`,
        params: {
          fromDate,
          toDate,
        },
      });
    } else {
      throw new Error('not implemented');
    }
  }
}
